import React, { Component } from 'react';
import Currency from '../currency'
export default class ExpoPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        // let table = document.getElementById("popupTab")
        // let tableHeight = table.innerHeight
        setTimeout(() => {
            let container = !!document.getElementById("cur_price") ? document.getElementById("cur_price").offsetTop : 0
            if (container > 140) {
                document.getElementById("tableDiv").scrollTo(0, (container - 140))
            }
        }, 500)
        // let myBetForm = document.getElementById("betFormBtns").offsetTop
        // let myBetFormPt = document.getElementById("betFormBtns").parentNode.parentNode.offsetTop
        // if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
        //     window.scrollTo(0, window.scrollY + 70)
        // }
    }
    fullLineExpo(expos) {
        let linearr = Object.keys(expos).toString()
        linearr = linearr.split(",").map(function (el) { return +el; });
        let tempExpo = {}
        let min = Math.min(...linearr)
        let max = Math.max(...linearr)
        for (let i = min; i <= max; i++) {
            if (!!expos[i.toString()]) {
                tempExpo[i.toString()] = expos[i.toString()]
            } else {
                tempExpo[i.toString()] = tempExpo[(i - 1).toString()]
            }
        }
        return tempExpo
    }
    render() {
        let lineExpo = Object.keys(this.props.lineExpo).length > 0 ? this.fullLineExpo(this.props.lineExpo) : {};
        let lineAgentExpo = Object.keys(this.props.lineAgentExpo).length > 0 ? this.fullLineExpo(this.props.lineAgentExpo) : {};
        // debugger
        let minRunnerId = "";
        let maxRunnerId = "";

        let minExpo;
        let maxExpo;
        let minAgentExpo;
        let maxAgentExpo;
        let agentMinRunnerId;
        let agentMaxRunnerId;
        let minRrId;
        let maxRrId;

        let expoArrKeys = Object.keys(lineExpo);
        let expoAgentArrKeys = Object.keys(lineAgentExpo);
        if (expoArrKeys.length > 0) {
            minRrId = Math.min(...expoArrKeys);
            maxRrId = Math.max(...expoArrKeys);
            minExpo = lineExpo[minRrId];
            maxExpo = lineExpo[maxRrId];
            minRunnerId = minRrId;
            maxRunnerId = maxRrId;

        }
        if (expoAgentArrKeys.length > 0) {
            agentMinRunnerId = Math.min(...expoAgentArrKeys);
            agentMaxRunnerId = Math.max(...expoAgentArrKeys);
            minAgentExpo = lineAgentExpo[agentMinRunnerId];
            maxAgentExpo = lineAgentExpo[agentMaxRunnerId];
            minRunnerId = !minRrId ? Math.min(...expoAgentArrKeys) : (Math.min(...expoAgentArrKeys) < minRrId ? Math.min(...expoAgentArrKeys) : minRrId);
            maxRunnerId = !maxRrId ? Math.max(...expoAgentArrKeys) : (Math.max(...expoAgentArrKeys) > maxRrId ? Math.max(...expoAgentArrKeys) : maxRrId);
        }

        let marketExpObj = {};
        if (minRunnerId !== '' || maxRunnerId !== '' || !!minRrId || !!maxRrId) {
            for (let indx = minRunnerId; indx <= maxRunnerId; indx++) {
                let totExpo1 = 0
                // debugger;
                // if(!!minAgentExpo)
                if (!!lineExpo[indx]) {
                    totExpo1 += lineExpo[indx].expo;
                }
                else {
                    totExpo1 += (!!minExpo && indx <= minRrId) ? minExpo.expo : (!!maxExpo && indx > maxRrId) ? maxExpo.expo : 0;
                }

                if (!!lineAgentExpo[indx]) {
                    totExpo1 = totExpo1 + lineAgentExpo[indx].expo;
                }
                else {
                    totExpo1 += (!!minAgentExpo && indx < agentMinRunnerId) ? minAgentExpo.expo : (!!maxAgentExpo && indx > agentMaxRunnerId) ? maxAgentExpo.expo : 0;
                }

                // if (totExpo1 !== 0) {
                    marketExpObj[indx] = { 'expo': totExpo1 };
                // }
            }
        }

        return (
            <>
                <div id="marketbetspopup" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    <div className="modal-dialog" style={{ maxWidth: "300px !important" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title mt-0" id="myModalLabel">Exposure</h5><button onClick={() => { this.props.hidePopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                {!!this.props.lineName && <div class="model-fancy-line-name">{this.props.lineName}</div>}
                                <div id="tableDiv" className="table-responsive overflow-y" style={{ maxHeight: "300px" }}>
                                    <table id="popupTab" className="table table-bordered font-12 table-sm mb-0">
                                        <tbody>
                                            {Object.keys(marketExpObj).map((i) => {
                                                let expo = marketExpObj[i].expo
                                                return <>
                                                    {this.props.expoPrice === i ? <tr id="cur_price" className={expo < 0 ? "lay-bg" : "back-bg"}>
                                                        <td>{i}</td>
                                                        <td style={{ width: "50%", fontWeight: "bold" }}><Currency className={"float-right bold"} amount={expo} isOnlyNumber={true} showColor={true} /></td>
                                                    </tr> : <tr className={expo < 0 ? "lay-bg" : "back-bg"}>
                                                        <td>{i}</td>
                                                        <td style={{ width: "50%", fontWeight: "bold" }}><Currency className={"float-right bold"} amount={expo} isOnlyNumber={true} showColor={true} /></td>
                                                    </tr>}
                                                </>
                                            })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={() => { this.props.hidePopup() }} className="btn btn-outline-danger waves-effect mx-auto" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopup() }}></div>
                </div>

            </>
        )
    }
}
